import { useQuery } from '@tanstack/react-query';
import { fetchUserAttendances } from '../api/attendanceApi';
import { attendanceKeys } from './attendanceKeys';

// X3 단계 1d (D3·D6): admin scope, 다른 유저 출퇴근 조회.
// PLAYER 본인 조회는 useMyAttendances 사용.
export function useUserAttendances(userId: string | undefined) {
  return useQuery({
    queryKey: attendanceKeys.adminUser(userId),
    queryFn: () => fetchUserAttendances(userId as string),
    enabled: !!userId,
    staleTime: 30_000,
  });
}
